import React, { createContext, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../AuthContext";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import axios from "axios";
import * as yup from "yup"
export const BankOwnerContext = createContext()

export default function BankOwnerProvider({ children }) {
    const { token } = useContext(AuthContext);    
    const [bankOwnerData,setBOData]=useState({
        name:"",
        profile:"",
        id:0,
        email:"",
        role:"",
        username:""
    })
    const [data, setData] = useState([]);// state to hold the data  
    const [allBanks, setAllBanks] = useState([]);//state to hold allthe banks
    const [bankCustomers, setBankCustomers] = useState([])//state to hold the customers that uses the bans
    const [bankFarmers, setBankFarmers] = useState([])//state to hold the farmers that uses the banks
    const [availableBanks, setAvailableBanks] = useState([]);
    const [allBankOwnersBanks, setAllBankOwnerBanks] = useState([]);//state to hold the banks a user has 
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage,setPostPerPage] = useState(4);
    const [bankToDel, setBankToDel] = useState(false);
    const [selectedBank, setSelectedBank] = useState("")
    const navigate = useNavigate();
    // Var to be able to
    const [admins, setAdmins] = useState([])    
    const baseUrl=process.env.REACT_APP_SECOND_BACKEND_URL;
    const bankUrl = `${baseUrl}/banks`;
    const bankOwnerUrl = `${baseUrl}/bank_owners`;
      
    
    useEffect(() => {
        if (!token) {
            navigate("/loginUser")
            return;                  
        }
        const decodedToken = jwtDecode(token); 
        const {role,profile,email,username,id,name}=decodedToken?.sub            
        if (role !== "bank_owner") {
                navigate("/unauthorized");
                return;
            }        
            fetchBankOwnerInfo(id)    
            setBOData((prevValues)=>(
                {
                    ...prevValues,
                    profile:profile?profile:prevValues?.profile,
                    email:email?email:prevValues.email,
                    username:username?username:prevValues?.username,
                    id:id?id:prevValues?.id,
                    name:name?name:prevValues?.name,
                    role:role?role:prevValues?.role
                }
            ))           
    }, [token]);
  
    useEffect(()=>{
        axios.get(bankUrl, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {                     // console.log(`Returned data is : ${response.data}`)           
                setAllBanks(response.data);
            })
            .catch(error => {
                console.error("Error fetching banks: ", error);
            });
    },[])

    const formik = useFormik({
        initialValues: {
            bank_name: '',
            bank_owner_username:bankOwnerData?.username,
        },
        validationSchema: yup.object().shape({
            bank_name: yup.string().required("Bank name is required").typeError("Bank name should be a string"),
            bank_owner_username:yup.string().required("Username is required").typeError("Ban_owner_username should be a string")
        }),
        onSubmit: async (values, { setSubmitting }) => {
            try {
                if (bankToDel) {
                    await sendDeleteBank(values);
                    setBankToDel(false)
                    formik.resetForm()
                } else {
                    await sendAddBank(values);
                    setBankToDel(false)
                    formik.resetForm()
                }
            } catch (error) {
                console.error("Error sending request", error);
            } finally {
                setSubmitting(false);
            }
        }
    });

    useEffect(() => {
        if (bankOwnerData.username && formik.values.bank_owner_username !== bankOwnerData?.username) {
            formik.setFieldValue("bank_owner_username", bankOwnerData?.username);
                    }
                    // console.log(formik.values.bank_owner_username)
    }, [bankOwnerData?.username, formik.values.bank_owner_username]);

    // useEffect(() => {
    //     if (data[0]?.Banks?.length>0 && allBanks?.length > 0) {              
    //             const bankOwnersBankIds = data[0].Banks.map((bank) => bank.id); // or use bank.name if id is not unique

    //             // Filter the banks that are not owned by the bank owner
    //             const filteredBanks = allBanks.filter(bank => !bankOwnersBankIds.includes(bank.id)); // or bank.name if using names
        
    //             // Set the filtered banks in the availableBanks state
    //             setAvailableBanks(filteredBanks);
            
    //              }
    //     else if (data[0]?.Banks?.length<1 && allBanks.length>0){
    //         setAvailableBanks(allBanks)
    //     }
    // }, [data, allBanks]);   

   const fetchBankOwnerInfo = async (id) => {  
    try {        
        const response = await axios.get(`${bankOwnerUrl}/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const allData = response?.data;   
        // console.log("fetched data",allData)     
        setData(allData);

        if (allData[0]?.Banks?.length > 0) {
            setAllBankOwnerBanks(allData[0]?.Banks);
            if(data[0].Banks.length>0  && data[0].AllBanks.length>0){
                const bankOwnerBankIds=data[0].Banks.map(bank=>bank.id)
                const filteredBanks=data[0]?.AllBanks.filter(bank=>!bankOwnerBankIds.includes(bank.id))
                setAvailableBanks(filteredBanks)
            }
            else if (data[0].Banks.length<1 && data[0].AllBanks.length>0){
                setAvailableBanks(data[0?.AllBanks])
            }

            // Flat map and deduplicate farmers by username
            const newFarmers = allData[0].Banks.flatMap(bank => bank.farmers || []);
            if (newFarmers.length > 0) {
                const uniqueNewFarmers = [...new Set(newFarmers.map(farmer => farmer.username))]
                    .map(username => newFarmers.find(farmer => farmer.username === username));
                setBankFarmers(uniqueNewFarmers);
            }

            // Flat map and deduplicate customers by username
            const newCustomers =  allData[0].Banks.flatMap(bank => bank.customers || []);
            if (newCustomers.length > 0) {
                const uniqueCustomers = [...new Set(newCustomers.map(customer => customer.username))]
                    .map(username => newCustomers.find(customer => customer.username === username));

                setBankCustomers(uniqueCustomers);
            }           
        
        }    
        
    } catch (error) {
        console.error("Error fetching bank owner info:", error);
    }
};


    const sendAddBank = async (values) => {
        try {
            const res = await fetch(`${baseUrl}/login/admin/bank_owners`,{
                method:"POST",
                headers:{
                    "Content-Type":"application/json",
                    "Authorization":`Bearer ${token}`
                },
                body:JSON.stringify(values)
            })
            if (res.ok) {               
                alert(`${values.bank_name} added successfully`);
               await fetchBankOwnerInfo(bankOwnerData?.id);
            } else {
               if (res.status===500){
                alert("An error ocurred adding bank ,please try again" );                                           
               }
               const result=await res.json() 
               alert(`An error ocurred adding ${values.bank_name}: ${result.Error || result.Message}`);               
            }

        } catch (error) {
            console.error(`An error occurred adding banks : ${error}`)
        }
    };
    
    
    const sendDeleteBank = async (values) => {
        try {
            if (!window.confirm(`Are you sure you want to delete ${values.bank_name}`)) return;

            const res = await fetch(`${baseUrl}/login/admin/bank_owners`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(values)
            });
            if (res.ok) {
                alert(`${values.bank_name} deleted successfully`);
                let filteredBanks=allBankOwnersBanks.filter(bank=>bank?.name!==values.bank_name)                
                setAllBankOwnerBanks(filteredBanks)
                fetchBankOwnerInfo(bankOwnerData?.id)
            } else {
                if (res.status===500){
                    alert("An error ocurred deleting  banks ,please try again" );                                                            
                }
                else{
                    const result=await res.json() 
                   alert(`An error ocurred deleting bank : ${values.bank_name}: ${result.Error || result.Message}`)
                }
            }
        } catch (error) {          
            console.error("Error sending delete request", error);
        }
    };

   
    useEffect(() => {
        fetchAdmins()
    }, [])
    // Function o ffetch for admins
    const fetchAdmins = async () => {
        try {
            const res = await fetch(`${baseUrl}/admins`)
            const newData = await res.json()
            setAdmins(newData)
        } catch (error) {
            console.error(`An error occurred fetching admins`, error)
        }
    }

    // Handles sending of messages between a bankOwner and another user
    const handleSendMessage = async (values) => {
        try {
            const res = await fetch(`${baseUrl}/messages`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(values)
            })
            if (res.ok) {                
                // alert("Message sent successfully")
                // fetchBankOwnerInfo(urlId)
            }
            else {
                if (res.status===500){
                    alert("An error ocurred deleting  bank ,please try again" );                                                   
                   }
                   const result=await res.json() 
                   alert(`An error ocurred sending message ${result.Error || result.Message}`);                  
            }
        } catch (error) {
            console.error("An error occurred sending messages", error)
        }
    }

    useEffect(()=>{
        fetchBankOwnerProfile()
    },[bankOwnerData?.username])
    const fetchBankOwnerProfile=async()=>{
        try {
           const res=await fetch(`${baseUrl}/uploads/${bankOwnerData?.profile}_profile_picture.png`,{
            headers:{
                'Authorzation':` Bearer ${token}`
            }
           })
           if(res.ok){
            let blob=await res.blob()
            let image=URL.createObjectURL(blob)
            setBOData(prev=>({
                ...prev,
                profile:image
            }))
           } 
           else{
            setBOData(prev=>({
                ...prev,
                profile:""
            }))
           }
        } catch (error) {
            
        }
    }
    // PAGINATION STATE
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;    
    const newBanksData = allBankOwnersBanks.length > 4 ? allBankOwnersBanks.slice(indexOfFirstPost, indexOfLastPost) : allBankOwnersBanks
    // console.log(bankFarmers)
    const paginate = (num) => {
        setCurrentPage(num)
    }
    const contextValue = {
        baseUrl,bankOwnerData,
        token, data,  allBanks, bankCustomers, bankFarmers, availableBanks,  allBankOwnersBanks, currentPage, postsPerPage, paginate, bankToDel, formik, newBanksData, setBankToDel, selectedBank, setSelectedBank, fetchBankOwnerInfo, admins, handleSendMessage
    }
    return (
        <BankOwnerContext.Provider value={contextValue}>
            {children}
        </BankOwnerContext.Provider>
    )
}
